import React, {useState} from 'react';
import {Button} from "react-bootstrap";
import {toAbsoluteUrl} from "../../../../../_metronic/_helpers";
import * as actions from "../../../Projects/_redux/projectsActions";
import can from "../../components/Permissions/can";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import PopupImportedCustomers from "../../../Projects/components/PopupImportedCustomers/PopupImportedCustomers";

export function ButtonImportCustomersToProject({projectId}) {
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const dispatch = useDispatch();
  const uploadFileFunc = (projectId, file) => {
    dispatch(actions.uploadCustomersForProject(projectId, file))
      .then(() => handleShowModal())
  };
  const onChange = (e) => {
    let file = e.target.files[0];
    uploadFileFunc(projectId, file);
  };

  const {markedList, ignoredList} = useSelector(
    (state) => (
      {
        markedList: state.markedIgnoredCustomers.markedList,
        ignoredList: state.markedIgnoredCustomers.ignoredList
      }
    ),
    shallowEqual
  );

  const disabledCondition = !can('full', 'projectsPage');

  const buttonClassName = `btn btn-icon btn-light btn-sm mx-3 custom-action-button
  ${disabledCondition ? `custom-disabled-button cursor-default` : ``}`;

  return (
    <>
      <Button
        className={buttonClassName}
        onClick={() => {
        }}
        disabled={disabledCondition}
      >
        <label className={'h-100 w-100 d-flex align-items-center justify-content-center mb-0 cursor-pointer'}>
          <img
            src={toAbsoluteUrl("/media/svg/Uploaded-file_brandColor.svg")}
            alt="icon"
          />
          <input
            type="file"
            className="d-none"
            onChange={onChange}
            onClick={(e) => {
              e.target.value = null
            }}
          />
        </label>
      </Button>
      <PopupImportedCustomers
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        markedList={markedList}
        ignoredList={ignoredList}
      />
    </>
  )
}